import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file ViewSwitch
 * @author Auto Generated by GlueCompiler
 */
import React from 'react';
import { withViewComponent } from '../../hoc/withViewComponent';
/* eslint-disable max-len */

export var ViewSwitch = withViewComponent(function ($p, $s, $c, $a) {
  var content = $p.content,
      children = $p.children,
      _$p$checked = $p.checked,
      checked = _$p$checked === void 0 ? false : _$p$checked,
      _$p$disabled = $p.disabled,
      disabled = _$p$disabled === void 0 ? false : _$p$disabled;
  return React.createElement("label", _objectSpread(_objectSpread({}, $a), {}, {
    className: $c(true, {
      checked: checked,
      disabled: disabled
    }, true),
    style: $s
  }), React.createElement("span", {
    className: $c('handle')
  }), React.createElement("span", {
    className: $c('inner')
  }, content), children);
}, 'switch', ['checked', 'disabled', 'content', 'children']);